
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 194 470","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M193.614 255.551c0 4.246-2.484 8.813-7.344 8.813h-13.218c-4.866 0-8.813-4.567-8.813-8.813V136.582h-5.875l.012 324.904c0 4.848-4.257 8.485-8.509 8.485H128.52c-4.866 0-8.342-2.478-8.342-7.326V82.239h39.656c17.625 0 31.968 9.942 33.798 23.281l-.017 150.031zM120.177 82.238v235h-10.282v143.938c0 4.848-3.947 8.813-8.812 8.813H79.052c-4.86 0-8.813-3.965-8.813-8.813V315.77H24.708L69.27 141.67 27.95 255.69c-1.82 4.245-6.679 6.672-10.93 4.854l-11.544-4.246c-4.262-1.21-6.683-6.07-4.865-10.918l51.034-140.094C56.51 91.946 70.956 82.24 84.927 82.24h35.25zM113.542.018c19.59 0 35.49 15.766 35.49 35.168s-15.9 35.168-35.49 35.168c-19.58 0-35.488-15.766-35.488-35.168S93.962.018 113.542.018z"}})])
          )
        }
      }
    